import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from "../../gameData.js";
import Abutton from '../../library/ExtendedObjects/AButton.js';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default class TrayBaseColors extends AContainer
{
    constructor(scene, parentCont, type, ind)
    {
        super(scene);

        this.scene = scene;
        this.pCont = parentCont;
        this.type = type;
        this.ind = ind;

        this.tabs = [
          gameData.maskLocalization.getLocalizedString("tabNames.trim", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.color", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.patterns", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.faces", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.patches", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.letters", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("tabNames.paint", gameData.maskLocalization.isDefault)
        ];

        this.dots = [];

        this.adjX = 0;
        this.adjY = 0;

        this.createTray();
    }

    createTray()
    {
        this.cursor = this.scene.addImage(0, 0, "dotCursor", this);
        this.cursor.setScale(0, 0);

        let size;
        if(this.type === "trim") {
            gameData.language === "english" ? size = 22 : size = 18;
        }
        else if(this.type === "bg" || this.type === "paint") {
            gameData.language === "english" ? size = 22 : size = 22;
        }
        this.nameplate = this.scene.addImage(55, -this.scene.maskAdj.y, "Tab", this);
        this.nameplateText = this.scene.addText(55, -this.scene.maskAdj.y + this.nameplate.height/2, 22, "0xFFFFFF", gameData.fonts.din_alternatebold, "nameplate", this, true);

        if(this.type === "trim") {
            this.nameplate.tint = "0xf2b640";
            this.nameplateText.text = this.tabs[0];
        }
        else if(this.type === "bg") {
            this.nameplate.tint = "0x3bccba";
            this.nameplateText.text = this.tabs[1];
        }
        else if(this.type === "paint") {
            this.nameplate.tint = "0x6c52cc";
            this.nameplateText.text = this.tabs[6];
        }

        ABCyaPhaser.Text.resizeFontToFitWidth(this.nameplateText, this.nameplate.getBounds().width - 10);
    }

    toggleBtns(onOff)
    {
        for(let i=0;i<this.list.length;i++){
            if(this.list[i] instanceof Abutton) this.list[i].setEnabled(onOff);
        }
    }

    tweenInCursor(color)
    {
        let dot = this.dots[gameData.dotColors.indexOf(color)];
        this.cursor.x = dot.x;
        this.cursor.y = dot.y + dot.height/2;
        this.cursor.setScale(0, 0);

        if(this.type === "trim") this.cursor.tint = "0xf2b640";
        else if(this.type === "bg") this.cursor.tint = "0x3bccba";
        else if(this.type === "paint") this.cursor.tint = "0x6c52cc";

        this.scene.killTween(this.cursor);
        if(this.type === "paint"){
            if(gameData.paintColor) this.scene.addTween(this.cursor, 500, {scaleX:1, scaleY:1}, Phaser.Math.Easing.Back.Out);
        } else {
            if(!gameData.faceActive && !gameData.patternActive) this.scene.addTween(this.cursor, 500, {scaleX:1, scaleY:1}, Phaser.Math.Easing.Back.Out);
        }
    }

    tweenOutCursor()
    {
        this.scene.killTween(this.cursor);
        this.scene.addTween(this.cursor, 100, {scaleX:0, scaleY:0}, Phaser.Math.Easing.None);
    }
}